import { render, staticRenderFns } from "./PartialLeadHistoryChat.vue?vue&type=template&id=0b961a23&scoped=true&"
import script from "./PartialLeadHistoryChat.vue?vue&type=script&lang=js&"
export * from "./PartialLeadHistoryChat.vue?vue&type=script&lang=js&"
import style0 from "./PartialLeadHistoryChat.vue?vue&type=style&index=0&id=0b961a23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b961a23",
  null
  
)

export default component.exports